<template>
<div class='circle' ref='circle' @mousedown='start' @mouseup='stop'
@mousemove='rotate' @mouseleave='stop' @mouseenter='mouseEnter' :style="cssVars">
  <img src='@/assets/aboveHead.svg' ref='img' draggable='false' ondragstart="return false;">
</div>
</template>
<script>

import { EventBus } from '@/eventBus.js';
const circleDiameter = 150;
const R2D = 180 / Math.PI;

export default {
  name: 'Above',
  data() {
    return {
      active: false,
      rotation: 0,
      startAngle: 0,
      angle: 0,
      diameter: circleDiameter,
      mouseDown: 0,
    }
  },
  computed: {
    cssVars() {
      EventBus.$emit('azimuth', this.angle + this.rotation);
      return {
        '--circle-diameter': this.diameter + 'px',
        '--rotation-angle' : (this.angle + this.rotation) + 'deg'
      }
    }
  },
  mounted() {
    EventBus.$on('mouseDown', this.handleMouseDown)
  },

  methods: {

    handleMouseDown(value) {
      this.mouseDown = value;
    },

    start(e) {
      const center = {
        x: circleDiameter / 2 + this.$refs.circle.getBoundingClientRect().left,
        y: circleDiameter / 2 + this.$refs.circle.getBoundingClientRect().top
      };
      const x = e.clientX - center.x;
      const y = e.clientY - center.y;
      this.startAngle = R2D * Math.atan2(y, x);
      this.active = true;
    },

    stop() {
      this.angle += this.rotation;
      this.rotation = 0;
      this.active = false;
    },

    mouseEnter(e) {
      if (this.mouseDown === 1) {
        this.start(e);
      }
    },

    rotate(e) {
      const center = {
        x: circleDiameter / 2 + this.$refs.circle.getBoundingClientRect().left,
        y: circleDiameter / 2 + this.$refs.circle.getBoundingClientRect().top
      };
      const x = e.clientX - center.x;
      const y = e.clientY - center.y;
      const d = R2D * Math.atan2(y, x);
      if (this.active) {
        this.rotation = d - this.startAngle;
      }
    }
  }
}
</script>

<style scoped>
img {
  z-index: 5;
  width: 100px;
  height: 100px;
  background-color: black;
  transform: rotate(var(--rotation-angle));
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.circle {
  z-index: 4;
  background-color: black;
  width: var(--circle-diameter);
  height: var(--circle-diameter);
  border-radius: 150px;
  border-style: inset;
  border-width: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

div {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

</style>
